module.exports = __webpack_public_path__ + "img/egg.31e5c90f.svg";